export const FAST_ORDER_PAGE_SIZES = [15, 25, 50, 100];

export const FAST_ORDER_SORT_FIELDS = [
  "product_id",
  "original_price",
  "discount_price",
  "sales_limit",
  "max_count",
];

export const DEFAULT_FAST_ORDER_QUERY = {
  currentPage: 1,
  perPage: 15,
  onlyActive: false,
  sortBy: "",
  sortOrder: "asc",
};

export const readFastOrderQuery = (searchParams) => {
  const pageValue = searchParams.get("page") || "";
  const page = Number(pageValue);
  const perPage = Number(searchParams.get("per_page"));
  const sortBy = searchParams.get("sort_by");
  const validSortBy = FAST_ORDER_SORT_FIELDS.includes(sortBy) ? sortBy : "";

  return {
    currentPage: /^\d+$/.test(pageValue) && Number.isSafeInteger(page) && page > 0
      ? page
      : DEFAULT_FAST_ORDER_QUERY.currentPage,
    perPage: FAST_ORDER_PAGE_SIZES.includes(perPage) ? perPage : DEFAULT_FAST_ORDER_QUERY.perPage,
    onlyActive: ["1", "true"].includes(searchParams.get("only_active")),
    sortBy: validSortBy,
    sortOrder: validSortBy && searchParams.get("sort_order") === "desc" ? "desc" : "asc",
  };
};

export const writeFastOrderQuery = (searchParams, query) => {
  const nextParams = new URLSearchParams(searchParams);
  const values = {
    page: query.currentPage !== DEFAULT_FAST_ORDER_QUERY.currentPage ? query.currentPage : null,
    per_page: query.perPage !== DEFAULT_FAST_ORDER_QUERY.perPage ? query.perPage : null,
    only_active: query.onlyActive ? "1" : null,
    sort_by: query.sortBy || null,
    sort_order: query.sortBy ? query.sortOrder : null,
  };

  Object.entries(values).forEach(([key, value]) => {
    if (value === null) {
      nextParams.delete(key);
    } else {
      nextParams.set(key, String(value));
    }
  });

  return nextParams;
};
